import { useEffect, useState } from "react";
import { Navigate, Outlet } from "react-router-dom";
import { authApi } from "./api";

export default function AdminProtected() {
  const [state, setState] = useState({ checking: true, ok: false });

  useEffect(() => {
    let cancelled = false;
    if (!authApi.hasToken()) {
      setState({ checking: false, ok: false });
      return;
    }
    authApi
      .me()
      .then(() => !cancelled && setState({ checking: false, ok: true }))
      .catch(() => !cancelled && setState({ checking: false, ok: false }));
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.checking) {
    return (
      <div className="min-h-screen bg-[#050505] grid place-items-center">
        <div className="flex items-center gap-3 text-zinc-400 text-sm font-display">
          <span className="w-3 h-3 rounded-full bg-gradient-brand animate-pulse" />
          Verificando sesión...
        </div>
      </div>
    );
  }
  if (!state.ok) return <Navigate to="/admin/login" replace />;
  return <Outlet />;
}
